module.exports = __webpack_public_path__ + "img/1207.94697c46.gif";